import {
  Alert,
  Backdrop,
  Card,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  ListItem,
  Snackbar,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppConfig from "appConfig";

function DawViewPage() {
  const pageTitle = `Display & Win`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [products, setProducts] = useState([]);
  const [retailers, setRetailers] = useState(0);
  const [visits, setVisits] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/daw/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setProducts(result.data.data.products);
            setRetailers(result.data.data.retailers);
            setVisits(result.data.data.visits);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={2} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox>
                    <ListItem>
                      <MDBox
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox>
                          <MDTypography variant="h6">
                            {campaign.title}
                          </MDTypography>
                          <MDTypography fontSize={12} color="text.secondary">
                            {campaign.account.name}
                          </MDTypography>
                        </MDBox>

                        <MDBox>
                          <img
                            src={`${AppConfig.api_media_url}${campaign.account.icon}`}
                            alt=""
                            width="18px"
                          />
                        </MDBox>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                  <MDBox mt={3}>
                    <MDTypography variant="h6" fontSize={14}>
                      Ends On
                    </MDTypography>
                    <MDTypography fontWeight="light" fontSize={13}>
                      {campaign.end_date}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Card>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontSize={14} mb={2}>
                    Products
                  </MDTypography>
                  {products.map((prd) => (
                    <MDBox mb={2}>
                      <ListItem divider>
                        <MDBox
                          width="100%"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          pb={1}
                        >
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              fontWeight="regular"
                              fontSize={14}
                            >
                              {prd.title}
                            </MDTypography>
                            <MDTypography
                              fontSize={12}
                              fontWeight="light"
                              color="text.secondary"
                            >
                              {`${campaign.account.currency}${(
                                prd.price / 100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </MDTypography>
                          </MDBox>

                          <MDBox align="center">
                            <MDTypography
                              variant="h6"
                              fontWeight="regular"
                              fontSize={14}
                            >
                              Points
                            </MDTypography>
                            <MDTypography fontSize={12} fontWeight="light">
                              {prd.points}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </ListItem>
                    </MDBox>
                  ))}
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {retailers}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          {retailers === 1 ? "Retaier" : "Retailers"}
                          <br />
                          Onboarded
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {visits}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          {visits === 1 ? "Visit" : "Visits"}
                          <br />
                          Performed
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <MDBox>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<Icon>edit_note</Icon>}
                  onClick={() => {
                    navigate(
                      `/activations/display-win/retailers/onboard/${ref}`,
                    );
                  }}
                >
                  Onboard Retailer
                </MDButton>
              </MDBox>
              <MDBox mt={3}>
                <MDButton
                  variant="outlined"
                  color="primary"
                  fullWidth
                  endIcon={<Icon>add_location</Icon>}
                  onClick={() => {
                    navigate(`/activations/display-win/${ref}/retailers/`);
                  }}
                >
                  Visit Retailer
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DawViewPage;
